import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { getCustomerList, addCustomerData } from "../../Redux/Gem/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import NewDataTable from "../DataTable/NewDataTable";
import { BsFillBookmarkStarFill } from "react-icons/bs";
import { FaEdit } from "react-icons/fa";
import { tr } from "date-fns/locale";

const Customer = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { customerlist } = useSelector((store) => store.gem);
    const [show, setShow] = useState(false);

    const [customerData, setCustomerData] = useState({
        customerId: "",
        customerName: "",
        customerShortName: "",
        actionType: "INSERT"
    });



    useEffect(() => {
        dispatch(getCustomerList(token));
    }, [dispatch, token, loginId]);

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const handleCustomerEdit = (customerData) => {
        setCustomerData({
            customerId: customerData.customerId,
            customerName: customerData.customerName,
            customerShortName: customerData.customerShortName,
            actionType: "UPDATE"

        });
        setShow(true);

    }

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Customer Short Name",
            selector: (row) => row?.customerShortName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Customer Name",
            selector: (row) => row?.customerName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <Tooltip text="Edit">
                    <FaEdit
                        className="text-warning" size={20}
                        onClick={() => handleCustomerEdit(row)}
                    />
                </Tooltip>

            ),

        },
    ];


    const clearLeaveInputFields = () => {
        setCustomerData({
            customerId: "",
            customerName: "",
            customerShortName: "",
            actionType: "INSERT"
        });
    };

    const handleClose = () => {
        clearLeaveInputFields();
        setShow(false);
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setCustomerData((prevData) => {
            let updatedData = {
                ...prevData,
                [id]: value,
            };
            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(addCustomerData(customerData, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(getCustomerList(token));
                        setShow(false);
                        clearLeaveInputFields();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong. Please try again later.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };


    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="card3">
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={customerlist || []}
                                tableName="CUSTOMERS"
                                totalRecord={customerlist?.length ?? 0}
                            />
                            <div className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary fw-bold mt-3"
                                    onClick={() => setShow(true)}
                                >
                                    ADD
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{`${customerData.actionType === "INSERT" ? "Add" : "Update"} Customer Data`}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="customerShortName" className="form-label">
                                            Customer Short Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="customerShortName"
                                            className="form-control"
                                            name="customerShortName"
                                            value={customerData.customerShortName}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="leaveCode" className="form-label">
                                            Customer Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="customerName"
                                            className="form-control"
                                            name="customerName"
                                            value={customerData.customerName}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            required
                                        />
                                    </div>

                                </div>
                                <div className="text-center">
                                    <button type="submit" className={`btn ${customerData.actionType === "INSERT" ? "btn-success" : "btn-warning"} mt-3`}>
                                        {`${customerData.actionType === "INSERT" ? "SUBMIT" : "UPDATE"}`}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default Customer;